<template>
  <div class="row">
    <div class="col-12">
      <div class="row" v-if="!property.id">
        <div class="col-12">
          <label class="">Property Identification Number (PIC) Lookup</label>
        </div>
        <div class="col-md-6 col-sm-12">
          <div class="row">
            <div class="col-md-6 mb-1">
              <el-input
                type="text"
                class="w-100"
                name="pic"
                v-model="picDataSearch.pic"
                placeholder="PIC"
              >
              </el-input>
              <div class="d-flex justify-content-between" v-if="!prefill">
                <div v-if="picResult.nlis">
                  <el-popover placement="bottom" width="250" trigger="hover">
                    <div class="fa-sm">
                      <div class="text-right">
                        <el-button
                          class="btn-secondary p-2"
                          @click="prefillResult('nlis')"
                          size="small"
                          >Prefill</el-button
                        >
                      </div>
                      <div class="py-1 border-bottom">
                        <strong>PIC: </strong>{{ picResult.nlis.PIC }}
                      </div>
                      <div class="py-1 border-bottom">
                        <strong>First name: </strong
                        >{{ picResult.nlis.First_name }}
                      </div>
                      <div class="py-1 border-bottom">
                        <strong>Last name: </strong
                        >{{ picResult.nlis.Last_name }}
                      </div>

                      <div class="py-1 border-bottom">
                        <strong>Business name: </strong
                        >{{ picResult.nlis.Business_x0020_Name }}
                      </div>
                      <div class="py-1 border-bottom">
                        <strong>PIC status: </strong
                        >{{ picResult.nlis.PIC_status }}
                      </div>
                      <div class="py-1 border-bottom">
                        <strong>Property name: </strong
                        >{{
                          !Array.isArray(picResult.nlis.Property_name)
                            ? picResult.nlis.Property_name
                            : picResult.nlis.Property_name[0]
                        }}
                      </div>
                      <div class="py-1 border-bottom">
                        <strong>Brand: </strong
                        >{{
                          !Array.isArray(picResult.nlis.Brand)
                            ? picResult.nlis.Brand
                            : picResult.nlis.Brand[0]
                        }}
                      </div>
                    </div>
                    <button
                      type="button"
                      slot="reference"
                      class="btn btn-link fa-sm p-0"
                    >
                      NLIS result
                    </button>
                  </el-popover>
                </div>
                <div v-if="picResult.ocs">
                  <el-popover placement="bottom" width="250" trigger="hover">
                    <div class="fa-sm">
                      <div class="text-right">
                        <el-button
                          class="btn-secondary p-2"
                          @click="prefillResult('ocs')"
                          size="small"
                          >Prefill</el-button
                        >
                      </div>
                      <div class="py-1 border-bottom">
                        <strong>PIC: </strong>{{ picResult.ocs.pic }}
                      </div>
                      <div class="py-1 border-bottom">
                        <strong>First name: </strong
                        >{{ picResult.ocs.first_name }}
                      </div>
                      <div class="py-1 border-bottom">
                        <strong>Last name: </strong
                        >{{ picResult.ocs.last_name }}
                      </div>

                      <div class="py-1 border-bottom">
                        <strong>Business name: </strong
                        >{{ picResult.ocs.business_name }}
                      </div>
                      <div class="py-1 border-bottom">
                        <strong>Property name: </strong
                        >{{ picResult.ocs.property_name }}
                      </div>
                      <div class="py-1 border-bottom">
                        <strong>Brand: </strong>{{ picResult.ocs.brand }}
                      </div>
                    </div>
                    <button
                      type="button"
                      slot="reference"
                      class="btn btn-link fa-sm p-0"
                    >
                      OCS result
                    </button>
                  </el-popover>
                </div>
              </div>
            </div>
            <div class="col-4 mb-1">
              <el-select
                class="w-100"
                v-model="picDataSearch.state"
                placeholder="State"
              >
                <el-option
                  v-for="state in regions"
                  :key="state.id"
                  :label="state.region"
                  :value="state.region"
                  >{{ state.region }}</el-option
                >
              </el-select>
            </div>
            <div class="col-2 mb-1">
              <el-button
                class="btn-secondary p-2"
                @click="searchPic"
                style="height: 40px"
                >Go</el-button
              >
            </div>
          </div>
        </div>
        <div class="col-12"><hr /></div>
      </div>
    </div>
    <div class="col-12 mt-2" v-loading="loading">
      <div class="row">
        <div class="col-md-6 col-sm-12 mt-2">
          <label class=""
            >PIC Number <span class="required-flag">*</span></label
          >
          <el-input
            type="text"
            class="w-100"
            name="pic"
            v-model="property.pic"
            placeholder="PIC"
            :class="prefill && !property.pic && 'prefill-input'"
          >
          </el-input>
        </div>
        <div class="col-md-6 col-sm-12 mt-2">
          <label class=""
            >Property name <span class="required-flag">*</span></label
          >
          <el-input
            type="text"
            class="w-100"
            name="pic"
            v-model="property.name"
            placeholder="Property name"
            :class="prefill && !property.name && 'prefill-input'"
          >
          </el-input>
        </div>
        <div class="col-md-6 col-sm-12 mt-2">
          <label class="">Phone</label>
          <vue-tel-input
            inputId="phone"
            mode="international"
            :class="prefill && !property.phone && 'prefill-input'"
            :onlyCountries="['AU', 'GB', 'NZ', 'US']"
            v-model="property.phone"
            class="w-100"
          />
        </div>
        <div class="col-md-6 col-sm-12 mt-2">
          <label class="">Email</label>
          <el-input
            type="text"
            class="w-100"
            name="pic"
            v-model="property.email"
            placeholder="Email"
            :class="prefill && !property.email && 'prefill-input'"
          >
          </el-input>
        </div>

        <div class="col-md-6 col-sm-12 mt-2">
          <label class="">Owning entity</label>
          <el-input
            type="text"
            class="w-100"
            name="pic"
            v-model="property.owning_entity"
            placeholder="Owning entity"
            :class="prefill && !property.owning_entity && 'prefill-input'"
          >
          </el-input>
        </div>
        <div class="col-md-6 col-sm-12 mt-2">
          <label class="">Town</label>
          <el-input
            type="text"
            class="w-100"
            name="pic"
            v-model="property.town"
            placeholder="Town"
            :class="prefill && !property.town && 'prefill-input'"
          >
          </el-input>
        </div>
        <div class="col-md-6 col-sm-12 mt-2">
          <label class="">Legal Name of Owner</label>
          <el-input
            type="text"
            class="w-100"
            name="pic"
            v-model="property.owner_legal_name"
            placeholder="Legal name of owner"
            :class="prefill && !property.owner_legal_name && 'prefill-input'"
          >
          </el-input>
        </div>

        <div class="col-md-6 col-sm-12 mt-2">
          <label class="">State</label>
          <el-select
            class="w-100"
            v-model="property.region_id"
            placeholder="State"
            :class="prefill && !property.region_id && 'prefill-input'"
          >
            <el-option
              v-for="(state, index) in regions"
              :key="state.id"
              :label="state.region"
              :value="state.id"
            />
          </el-select>
        </div>

        <div class="col-md-6 col-sm-12 mt-2">
          <label class=""
            >Property Type <span class="required-flag">*</span></label
          >
          <el-select
            class="w-100"
            v-model="property.property_type"
            placeholder="Property Type"
            @change="changePropertyType"
            :class="prefill && !property.property_type && 'prefill-input'"
          >
            <el-option
              v-for="(item, index) in propertyTypes"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </div>
        <div class="col-md-6 col-sm-12 mt-2" v-if="showAdminFields">
          <label class="">PIC Type</label>
          <el-select
            class="w-100"
            v-model="property.pic_type"
            placeholder="State"
          >
            <el-option
              v-for="(item, index) in picTypes"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </div>
        <div class="col-md-6 col-sm-12 mt-4 pt-3" v-else>
          <div>
            Does
            <strong>{{
              initial_lead && initial_lead.name
                ? initial_lead.name
                : "the business"
            }}</strong>
            own this property? <span class="required-flag">*</span>
          </div>
          <el-radio
            v-model="property.pic_type"
            v-for="(item, index) in picTypes"
            :key="index"
            :label="item.id"
            >{{ item.owned }}</el-radio
          >
        </div>
      </div>
      <div class="row" v-if="showAdminFields">
        <div class="col-md-6 col-sm-12 mt-2">
          <div class="row">
            <div class="col-md-6 col-sm-12 mt-2">
              <label class="">Cattle ADG</label>
              <el-input
                type="number"
                class="w-100"
                name="pic"
                v-model="property.cattle_average_daily_gain"
                placeholder="Cattle ADG"
              >
              </el-input>
            </div>
            <div class="col-md-6 col-sm-12 mt-2">
              <label class="">Sheep ADG</label>
              <el-input
                type="number"
                class="w-100"
                name="pic"
                v-model="property.sheep_average_daily_gain"
                placeholder="Sheep ADG"
              >
              </el-input>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-12 mt-2 d-flex justify-content-between">
          <div class="mt-5">
            <el-switch v-model="property.is_nlis_confirmed"></el-switch>
            NLIS Confirmation Received
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 mt-2 col-sm-12">
          <address-not-found
            @update="updateAddress"
            :layout="4"
            :data="{
              not_found: not_found,
              address: address,
              required: true,
            }"
          ></address-not-found>
        </div>
        <div class="col-md-12 col-sm-12" v-if="!not_found">
          <label class="">Address <span class="required-flag">*</span></label>
          <google-maps-autocomplete
            class="w-100"
            :value="property.address"
            @coordinates="saveCoordinates"
            v-on:address-components="saveAddresses"
            placeholder="10 Street Name"
            :class="prefill && !property.address && 'prefill-input'"
          ></google-maps-autocomplete>
        </div>
      </div>
    </div>
    <div
      class="col-12 mt-2"
      :class="backButton ? ' d-flex justify-content-between' : 'text-right'"
    >
      <el-button
        v-if="backButton"
        class="btn-secondary"
        @click="back()"
        :disabled="loading"
      >
        {{ backButton }}
      </el-button>
      <el-button class="btn-primary" @click="addPic" :disabled="loading">
        {{ property.id || property.index >= 0 ? "Update" : "Add" }}
      </el-button>
    </div>
  </div>
</template>

<script>
import Form from "form-backend-validation";
import AddressNotFound from "./AddressNotFound.vue";
export default {
  components: { AddressNotFound },
  props: {
    initial_property: {
      type: Object,
      default: () => {
        return null;
      },
    },
    backButton: {
      type: String,
      default: () => {
        return null;
      },
    },
    showAdminFields: {
      type: Boolean,
      default: true,
    },
    prefill: {
      type: Boolean,
      default: false,
    },
    initial_lead: {
      type: Object,
      required: false,
      default: () => {
        return null;
      },
    },
  },
  data() {
    return {
      states: ["ACT", "NT", "QLD", "TAS", "NSW", "WA", "SA", "VIC"],
      picDataSearch: { pic: null, state: null },
      loading: false,
      property: this.initial_property
        ? this.initial_property
        : {
            pic: "",
            name: "",
            owning_entity: "",
            phone: "",
            owner_legal_name: "",
            address: "",
            region_id: "",
            extra_attributes: {
              address: null,
            },
            lng: "",
            lat: "",
            property_type: null,
            cattle_average_daily_gain: null,
            sheep_average_daily_gain: null,
            is_nlis_confirmed: false,
            pic_type: null,
          },
      form: new Form(),
      regions: [],
      picResult: { nlis: null, ocs: null },
      not_found: false,
      address: "",
      picTypes: [
        {
          id: "owned",
          name: "owned",
          owned: "Yes",
        },
        {
          id: "agisted",
          name: "agisted",
          owned: "No",
        },
      ],
      propertyTypes: [
        {
          id: "backgrounder",
          name: "backgrounder",
          sheep: 0.08,
          cattle: 0.7,
        },
        {
          id: "feedlot",
          name: "feedlot",
          sheep: 0.3,
          cattle: 1.7,
        },
      ],
    };
  },
  computed: {},
  mounted() {
    this.getRegions();
  },
  methods: {
    changePropertyType() {
      let propertyType = this.propertyTypes.find(
        (p) => p.id == this.property.property_type
      );
      this.property.sheep_average_daily_gain = propertyType.sheep;
      this.property.cattle_average_daily_gain = propertyType.cattle;
    },
    prefillResult(type) {
      if (type == "nlis") {
        let nlis = this.picResult.nlis;
        this.property.pic = nlis.PIC;
        this.property.region_id = this.regions.find(
          (r) => r.region == this.picDataSearch.state
        ).id;
        this.property.name = Array.isArray(nlis.Property_name)
          ? nlis.Property_name.length > 0
            ? nlis.Property_name[0]
            : ""
          : nlis.Property_name;
        this.property.owning_entity = Array.isArray(nlis.Business_x0020_Name)
          ? nlis.Business_x0020_Name.length > 0
            ? nlis.Business_x0020_Name[0]
            : ""
          : nlis.Business_x0020_Name;
        let first_name = Array.isArray(nlis.First_name)
          ? nlis.First_name[0]
          : nlis.First_name;
        let last_name = Array.isArray(nlis.Last_name)
          ? nlis.Last_name[0]
          : nlis.Last_name;
        this.property.owner_legal_name = (first_name + " " + last_name).trim();
      }
      if (type == "ocs") {
        let ocs = this.picResult.ocs;
        this.property.pic = ocs.pic;
        this.property.region_id = this.regions.find(
          (r) => r.region == this.picDataSearch.state
        ).id;
        this.property.name = ocs.property_name;
        this.property.owning_entity = ocs.business_name;
        this.property.owner_legal_name = (
          ocs.first_name +
          " " +
          ocs.first_name
        ).trim();
      }
    },
    updateAddress(data) {
      this.not_found = data.not_found;
      this.address = data.address;
    },
    async getRegions() {
      axios
        .get("/api/v2/public/regions", {
          params: {
            no_paginate: true,
          },
        })
        .then((res) => {
          this.regions = res.data;
        });
    },
    saveAddresses: function (address) {
      this.property.extra_attributes = { address: address };
    },
    saveCoordinates(payload) {
      this.property.lng = payload.lng;
      this.property.lat = payload.lat;
    },
    back() {
      this.$emit("back");
    },
    addPic() {
      if (this.not_found) {
        this.property.extra_attributes = {
          address: this.address,
        };
      }
      if (!this.property.pic) {
        this.$message.error("PIC number is required");
        return;
      }
      if (!this.property.name) {
        this.$message.error("Property name is required");
        return;
      }
      if (!this.property.property_type) {
        this.$message.error("Property type is required");
        return;
      }
      if (!this.property.pic_type) {
        this.$message.error("Property ownership is required");
        return;
      }
      if (
        !this.property.address &&
        !this.address &&
        !this.property.extra_attributes.address
      ) {
        this.$message.error("Address is required");
        return;
      }
      this.$emit("add", this.property);
    },

    clearForm() {
      this.property = {
        pic: "",
        name: "",
        owning_entity: "",
        phone: "",
        owner_legal_name: "",
        address: "",
        region_id: "",
        extra_attributes: {
          address: null,
        },
        lng: "",
        lat: "",
      };
    },
    searchPic() {
      this.clearForm();
      this.loading = true;
      axios
        .get(`/api/v1/admin/pic_search`, {
          params: {
            pic: this.picDataSearch.pic,
            state: this.picDataSearch.state,
          },
        })
        .then((res) => {
          this.picResult = {
            nlis: res.data.nlis ? res.data.nlis[0] : null,
            ocs: res.data.ocs,
          };
          if (this.prefill && this.picResult.nlis) {
            this.prefillResult("nlis");
          } else if (
            !this.prefill &&
            (this.picResult.nlis || this.picResult.ocs)
          ) {
            this.$message.success("Property found");
          } else {
            this.$message.error("Property not found");
          }
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        })
        .finally((_) => {
          this.loading = false;
        });
    },
  },
};
</script>
<style>
.prefill-input,
.prefill-input > input,
.prefill-input > div > input {
  background-color: #ececec !important;
}
</style>
